module.exports = __webpack_public_path__ + "static/media/cart.2913dc58.svg";